export class FetchTherapistListAction {
  static readonly type =
    '[Therapist List action] Fetch Therapists Enrolled By Admin';
  constructor(public adminID: string) {}
}
